import Label   from '../ui/components/Label'
import Iconify from '../ui/components/Iconify'
import React   from 'react'

const deliveryStatusMap = {
  waiting: { icon: 'material-symbols:schedule', color: 'info' },
  sent: { icon: 'material-symbols:question-exchange', color: 'secondary' },
  notSent: { icon: 'material-symbols:cancel', color: 'warning' },
  delivered: { icon: 'material-symbols:bookmark-check', color: 'success' },
  notDelivered: { icon: 'material-symbols:error', color: 'error' },
  notDeliverable: { icon: 'material-symbols:mail-lock', color: 'error' },
  incoming: { icon: 'material-symbols:mark-email-read', color: 'info' },
  limit_exceeded: { icon: 'material-symbols:block', color: 'error' },
  low_credit: { icon: 'material-symbols:account-balance-wallet', color: 'warning' },
  imported: { icon: 'material-symbols:bookmark-check', color: 'success' },
  unprocessed: { icon: 'material-symbols:warning', color: 'warning' },
  failed: { icon: 'material-symbols:report', color: 'error' },
  null: { icon: 'material-symbols:help', color: 'default' },
}

function MessageStatusBadge({ t, message }) {
  let statusKey = message.deliveryStatus
  if (!statusKey && message.received) {
    statusKey = 'incoming'
  }
  if (message.imported) {
    statusKey = 'imported'
  } else if (!message.deliveryStatus && message.sent) {
    statusKey = 'unprocessed'
  }
  const status = deliveryStatusMap[statusKey]
  return (
    <Label color={status.color} startIcon={<Iconify icon={status.icon} />}>
      {t(`deliverystatus-${statusKey}`)}
    </Label>
  )
}

export default MessageStatusBadge